<template>
  <div
    id="blog"
    style="width: 90%"
  >
    <div
      id="cards-container"
      v-if="posts && posts.length > 0"
    >
      <v-card
        class="mx-auto card-style"
        outlined
        v-for="(post, index) in posts"
        v-show="checkLanguage(post.language)"
        :key="index"
        :id="post.id + '-card'"
      >

        <v-list-item three-line>
          <v-list-item-content>
            <div class="overline mb-4">
              {{ typeof post.createdAt === 'string' ?  post.createdAt : new Date(post.createdAt.seconds * 1000).toLocaleString() }}
            </div>

            <expandable-image :src="post.image" />

            <v-list-item-title
              class="headline mb-1"
              v-if="post.videoUrl || post.audioUrl"
            >
              <video
                v-if="post.videoUrl"
                :src="post.videoUrl"
                controls
              ></video>

              <audio
                v-if="post.audioUrl"
                :src="post.audioUrl"
                controls
              ></audio>

            </v-list-item-title>
            <!--  -->
            <v-list-item-subtitle
              :id="post.id"
              v-if="post.language === 'pt' && language === 'pt'"
              :ref="createRefId(post.id)"
              :style="checkScrollHeight(post.id)"
            >
              {{ post.textPt }}
            </v-list-item-subtitle>

            <!--  -->
            <v-list-item-subtitle
              :id="post.id"
              v-if="post.language === 'en' && language === 'en'"
              :ref="createRefId(post.id)"
              :style="checkScrollHeight(post.id)"
            >
              {{ post.textEn }}
            </v-list-item-subtitle>
          </v-list-item-content>

        </v-list-item>

        <v-card-actions>
          <v-btn
            icon
            @click="likeOrDislike(post.id, 'like')"
          >
            {{ post.likes ? post.likes : '0' }}
            <v-icon>mdi-thumb-up</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="likeOrDislike(post.id, 'dislike')"
          >
            {{ post.dislikes ? post.dislikes : '0' }}
            <v-icon>mdi-thumb-down</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <h2 v-show="showNoMorePosts">
      {{ noMorePostsMessage }}
    </h2>
    <div id="circular-progress-element" style="height: 100px" v-if="showProgress">
      <v-progress-circular
        style="width: 100%"
        indeterminate
        color="circularProgressColor"
        class="bottom"
      >
        {{ progressMessage }}
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
// import VueExpandableImage from "vue-expandable-image"

import mixins from "../assets/mixins.js"
import { eventBus } from "../main.js"

export default {
  name: "blog",
  components: {
    // "expandable-image": VueExpandableImage
  },
  mixins: [mixins],
  computed: {
    imgSize() {
      if (this.viewPortWidth < 430) return 105
      else if (this.viewPortWidth < 768) return 130

      return 190
    }
  },
  mounted() {
    eventBus.$on("updateLanguage", this.setLang)

    window.scrollTo(0, 0)

    const debugging = false
    if (debugging) {
      this.baseUrl = "http://localhost:3000"
    } else {
      this.baseUrl = "https://login-anantadeva.herokuapp.com"
    }

    this.url = new URL(this.baseUrl + this.postsUrl)

    let posts = sessionStorage.getItem("posts")

    if (window.location.href.indexOf("localhost") > -1 && posts) {
      this.posts = JSON.parse(posts)
      this.lastPtTimestamp = sessionStorage.getItem("lastPtTimestamp")
      this.lastEnTimestamp = sessionStorage.getItem("lastEnTimestamp")
      this.lastBothTimestamp = sessionStorage.getItem("lastBothTimestamp")
    } else {
      this.fetchPosts()
    }

    window.onbeforeunload = () => {
      sessionStorage.removeItem("lastPtTimestamp")
      sessionStorage.removeItem("lastEnTimestamp")
      sessionStorage.removeItem("lastBothTimestamp")
    }

    window.addEventListener("resize", () => {
      for (let key in this.$refs)
        if (key.indexOf("postTextId_") > -1) {
          let elArray = this.$refs[key]
          if (elArray) {
            for (let viewEl of elArray) {
              if (viewEl.style.display != "none") {
                viewEl.style.height = viewEl.scrollHeight + "px"
              }
            }
          }
        }
    })

    window.addEventListener("scroll", () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 150
      ) {
        this.bottom = true
      } else {
        this.bottom = false
      }
    })
  },
  data() {
    return {
      progressMessage: null,
      showNoMorePosts: false,
      noMorePostsMessage: null,
      lastPtTimestamp: null,
      lastEnTimestamp: null,
      lastBothTimestamp: null,
      baseUrl: null,
      postsUrl: "/posts",
      posts: [],
      viewPortWidth: window.innerWidth,
      lang: null,
      bottom: false,
      showProgress: false,
      circularProgressColor: "primary",
      circularProgressColors: ["primary", "red", "purple", "green", "amber"],
      postsLoaderCounter: 0,
      url: null
    }
  },
  watch: {
    lang(lang) {
      lang === "pt"
        ? ((this.noMorePostsMessage = "Fim das postagens"),
          (this.progressMessage =
            "Aguarde um instante enquanto trazemos as postagens!"))
        : ((this.noMorePostsMessage = "No more posts"),
          (this.progressMessage =
            "Wait a sec while we bring for your delight the more recent posts!"))
    },
    bottom(bottom) {
      if (bottom) {
        this.addPosts()
      }
    }
  },
  methods: {
    createRefId(postId) {
      return `postTextId_${postId}`
    },

    checkScrollHeight(postId) {
      setTimeout(() => {
        let elArray = this.$refs[`postTextId_${postId}`]
        if (elArray) {
          for (let viewEl of elArray) {
            viewEl.style.height = viewEl.scrollHeight + "px"
            viewEl.style.display = "contents"
          }
        }
      }, 2500)
    },

    fetchPosts() {
      this.showProgress = true
      fetch(this.url, {
        method: "GET"
      })
        .then(response => response.json())
        .then(result => {
          if (result.posts && result.posts.length > 0) {
            if (this.posts.length === 0) this.posts = result.posts
            else {
              for (let post of result.posts) {
                this.posts.push(post)
              }
            }

            result.lastPtTimestamp
              ? (this.lastPtTimestamp = result.lastPtTimestamp)
              : null
            result.lastEnTimestamp
              ? (this.lastEnTimestamp = result.lastEnTimestamp)
              : null
            result.lastBothTimestamp
              ? (this.lastBothTimestamp = result.lastBothTimestamp)
              : null

            // sessionStorage.setItem("posts", JSON.stringify(this.posts))
            sessionStorage.setItem(
              "lastPtTimestamp",
              JSON.stringify(this.lastPtTimestamp)
            )
            sessionStorage.setItem(
              "lastEnTimestamp",
              JSON.stringify(this.lastEnTimestamp)
            )
            sessionStorage.setItem(
              "lastBothTimestamp",
              JSON.stringify(this.lastBothTimestamp)
            )
            setTimeout(() => {
              this.showProgress = false
            }, 1000)
          } else if (result.posts && result.posts.length === 0) {
            this.showNoMorePosts = true
            this.showProgress = false
          }
        })
        .catch(err => {
          console.error(err)
        })
    },

    addPosts() {
      if (
        this.lastPtTimestamp &&
        this.lastEnTimestamp &&
        this.lastBothTimestamp
      ) {
        this.url.searchParams.delete("lastPtTimestamp")
        this.url.searchParams.delete("lastEnTimestamp")
        this.url.searchParams.delete("lastBothTimestamp")
        if (this.lang === "pt") {
          this.url.searchParams.append("lastPtTimestamp", this.lastPtTimestamp)
        } else {
          this.url.searchParams.append("lastEnTimestamp", this.lastEnTimestamp)
        }
        this.url.searchParams.append(
          "lastBothTimestamp",
          this.lastBothTimestamp
        )

        this.fetchPosts()
      }
    },

    checkLanguage(postLanguage) {
      if (
        (postLanguage === "pt" && this.language === "pt") ||
        (postLanguage === "en" && this.language === "en")
      )
        return true

      return false
    },

    likeOrDislike(postId, type) {
      
      fetch(this.baseUrl + "/likeOrDislike", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ type, postLanguage: this.lang, postId })
      })
        .then(response => response.json())
        .then(result => {
          console.log(result)
        })
        .catch(err => {
          console.error(err)
        })
    }
  }
}
</script>

<style>
video {
  width: 50%;
  margin: 0 auto;
}

audio {
  height: 55px !important;
  margin: 1%;
  width: 95%;
}

.v-list-item__title.headline.mb-1 {
  display: flex;
}

.card-style {
  padding: 3%;
  margin: 3%;
}

.v-list-item__subtitle {
  overflow-x: hidden;
  /* overflow-y: auto; */
  display: contents;
  /* height: 350px; */
  font-size: 20px;
  font-weight: 900;
}

.v-list-item__subtitle::-webkit-scrollbar {
  width: 0.3em;
}
.v-list-item__subtitle::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.v-list-item__subtitle::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}

.v-avatar.v-list-item__avatar.v-avatar--tile.grey {
  height: 10rem;
  min-width: 10rem;
  width: 160px;
}

.v-progress-circular__info {
  top: 140%;
  position: absolute;
}

@media screen and (max-width: 500px) {
  .v-avatar.v-list-item__avatar.v-avatar--tile.grey {
    height: 7rem;
    min-width: 7rem;
    width: 112px;
  }
  video {
    width: 90%;
  }
}

</style>